'use client';

import React, { Suspense } from "react";
import { MetaTags } from "@/components/MetaTags";
import { useSearchParams } from 'next/navigation';
interface MetaTagsHeaderProps {
  children: React.ReactNode;
}
const MetaTagsHeader: React.FC<MetaTagsHeaderProps> = ({
  children
}) => {
  const searchParams = useSearchParams();
  return <>
        <MetaTags searchParams={searchParams} data-sentry-element="MetaTags" data-sentry-source-file="layoutClientHeader.tsx" />
        {children}
    </>;
};
export default function LayoutClientHeader({
  children
}: {
  children?: React.ReactNode;
}) {
  return <>
        <Suspense data-sentry-element="Suspense" data-sentry-source-file="layoutClientHeader.tsx">
            <MetaTagsHeader children={children} data-sentry-element="MetaTagsHeader" data-sentry-source-file="layoutClientHeader.tsx" />
        </Suspense>
    </>;
}